<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
      step: 1,

      area: null,

      especialidades: null,
      especialidade: '',

      profissionais: null,
      profissional: '',

      date: '',
      hour: '',
      motive: '',

      confirm: {
        modal: false,
        loading: false,
      }
    };
  },
  methods: {
    getEspecialidades() {
      this.especialidades = null;

      api
        .get('telemedicina/especialidades/medicina')
        .then((response) => {
          if (response.data.status == 'success') {
            this.area = response.data.area;
            this.especialidades = response.data.especialidades;
          } else {
            this.$router.push('/telemedicina/agendamento');
          }
        })
        .catch(error => {
          if (error) {
            this.$router.push('/telemedicina/agendamento');
          }
        })
    },
    selectEspecialidade(especialidade) {
        this.step = 2;
        this.especialidade = especialidade;
        this.profissional = '';
        this.date = '';
        this.hour = '';
        this.motive = '';
        this.getProfissionais();
    },
    changeEspecialidade() {
      this.step = 1;
      this.especialidade = '';
      this.profissionais = null;
      this.profissional = '';
      this.date = '';
      this.hour = '';
      this.motive = '';
    },
    getProfissionais() {
      if (this.especialidade && this.especialidade.id) {
        this.profissionais = null;

        api
          .post('telemedicina/profissionais/medicina', {
            specialty: this.especialidade.name
          })
          .then((response) => {
            if (response.data.status == 'success') {
              this.profissionais = response.data.profissionais;
            }
          })
          .catch(error => {
            if (error) {
              this.profissionais = [];
            }
          })
      }
    },
    selectProfissional(profissional) {
      this.step = 3;
      this.profissional = profissional;
      this.date = '';
      this.hour = '';
      this.motive = '';
    },
    changeProfissional() {
      this.step = 2;
      this.profissional = '';
      this.date = '';
      this.hour = '';
      this.motive = '';
    },
    selectDate(date) {
      this.step = 4;
      this.date = date;
      this.hour = '';
      this.motive = '';
    },
    changeDate() {
      this.step = 3;
      this.date = '';
      this.hour = '';
      this.motive = '';
    },
    selectHour(hour) {
      this.step = 5;
      this.hour = hour;
      this.motive = '';
    },
    changeHour() {
      this.step = 4;
      this.hour = '';
      this.motive = '';
    },
    showConfirmar() {
      this.confirm.modal = false;
      this.confirm.modal = true;
    },
    sendAgendamento() {
      if (this.profissional && this.profissional.id && this.hour) {
        this.confirm.loading = true;

        api
          .post('telemedicina/agendamento', {
            professional: this.profissional.id,
            schedule: this.hour,
            motive: this.motive,
          })
          .then((response) => {
            if (response.data.status == 'success') {
              this.$router.push('/telemedicina/consultas/' + response.data.id);
            } else {
              this.$toast.error(response.data.message);
            }
          })
          .catch(error => {
            if (error) {
              this.confirm.loading = false;
            }
          })
          .finally(() => {
            this.confirm.loading = false;
          })
      }
    },
  },
  mounted() {
    this.getEspecialidades();
  }
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(49, 47, 79, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/telemedicina">Telemedicina</router-link></li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Agendamento</h3>
        <p>Marque suas consultas de forma rápida e prática.</p>
      </div>
    </div>

    <b-progress :value="step" max="4" class="mb-5" variant="default"></b-progress>

    <template v-if="step == 1">
      <h5 v-if="especialidades" class="mb-4">Qual especialidade médica você gostaria de agendar?</h5>
      <div v-if="!especialidades" class="text-center">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
      <div class="card" v-else-if="especialidades && especialidades.length == 0">
        <div class="card-body">
          nenhum profissional disponível no momento
        </div>
      </div>
      <div v-else>
        <div v-for="(list, letter) in especialidades" :key="letter">
          <p class="my-2">{{ letter }}</p>

          <button class="mb-2 p-0 border-0 bg-transparent w-100 text-left" v-for="(row, index) in list" :key="index" v-on:click="selectEspecialidade(row);">
            <div class="card card-icon mb-0">
              <div class="card-body py-2 d-flex justify-content-between align-items-center">
                <div class="flex-fill">
                  <h5 class="m-0 text-dark font-size-16"><strong>{{ row.name }}</strong></h5>
                </div>
                <div class="ml-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(50, 47, 79, 1);">
                    <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path>
                  </svg>
                </div>
              </div>
            </div>
          </button>
        </div>
      </div>
    </template>

    <template v-else-if="step == 2">
      <div class="d-flex justify-content-between align-items-center mb-5">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(50, 47, 79, 1);">
            <path
              d="M16.97 4.757a.999.999 0 0 0-1.918-.073l-3.186 9.554-2.952-6.644a1.002 1.002 0 0 0-1.843.034L5.323 12H2v2h3.323c.823 0 1.552-.494 1.856-1.257l.869-2.172 3.037 6.835c.162.363.521.594.915.594l.048-.001a.998.998 0 0 0 .9-.683l2.914-8.742.979 3.911A1.995 1.995 0 0 0 18.781 14H22v-2h-3.22l-1.81-7.243z">
            </path>
          </svg>
        </div>
        <div class="ml-2 flex-fill">
          <h5 class="mb-0">{{ especialidade.name }}</h5>
        </div>
        <button class="btn btn-outline-default py-1 rounded-sm" v-on:click="changeEspecialidade();">Alterar</button>
      </div>

      <div v-if="!profissionais" class="text-center">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
      <div v-else-if="profissionais && profissionais.length == 0">
        <div class="card">
          <div class="card-body text-center">
            Nenhum profissional disponível no momento.
          </div>
        </div>

        <button class="mt-4 btn btn-default btn-lg btn-block" v-on:click="changeEspecialidade();">
          Voltar
        </button>
      </div>
      <div v-else>
        <h5 class="mb-4">Selecione o profissional desejado</h5>

        <button class="mb-2 p-0 border-0 bg-transparent w-100 text-left" v-for="(pro, index) in profissionais" :key="index" v-on:click="selectProfissional(pro);">
          <div class="card card-icon mb-0">
            <div class="card-body d-flex justify-content-between align-items-center">
              <div v-if="pro.image">
                <img class="rounded-circle header-profile-user" :src="pro.image" alt="" />
              </div>
              <div v-else class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
                  <path d="M15 2.013H9V9H2v6h7v6.987h6V15h7V9h-7z"></path>
                </svg>
              </div>
              <div class="ml-3 w-75 pt-1">
                <h5 class="m-0 text-dark font-size-16"><strong>{{ pro.name }}</strong></h5>
                <p class="m-0 text-dark text-uppercase">{{ pro.class }} – {{ pro.region }} {{ pro.register }}</p>
              </div>
              <div class="ml-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(50, 47, 79, 1);">
                  <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path>
                </svg>
              </div>
            </div>
          </div>
        </button>
      </div>
    </template>

    <template v-else-if="step == 3">
      <div class="d-flex justify-content-between align-items-center mb-5">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(50, 47, 79, 1);">
            <path
              d="M16.97 4.757a.999.999 0 0 0-1.918-.073l-3.186 9.554-2.952-6.644a1.002 1.002 0 0 0-1.843.034L5.323 12H2v2h3.323c.823 0 1.552-.494 1.856-1.257l.869-2.172 3.037 6.835c.162.363.521.594.915.594l.048-.001a.998.998 0 0 0 .9-.683l2.914-8.742.979 3.911A1.995 1.995 0 0 0 18.781 14H22v-2h-3.22l-1.81-7.243z">
            </path>
          </svg>
        </div>
        <div class="ml-2 flex-fill">
          <h5 class="mb-0">{{ especialidade.name }}</h5>
        </div>
        <button class="btn btn-outline-default py-1 rounded-sm" v-on:click="changeEspecialidade();">Alterar</button>
      </div>

      <div class="card card-icon">
        <div class="card-body d-flex align-items-center">
          <div v-if="profissional.image">
            <img class="rounded-circle header-profile-user" :src="profissional.image" alt="" />
          </div>
          <div v-else class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
              <path d="M15 2.013H9V9H2v6h7v6.987h6V15h7V9h-7z"></path>
            </svg>
          </div>
          <div class="ml-3 w-75 pt-1">
            <h5 class="m-0 text-dark font-size-16"><strong>{{ profissional.name }}</strong></h5>
            <p class="m-0 text-dark text-uppercase">{{ profissional.class }} – {{ profissional.region }} {{ profissional.register }}</p>
          </div>
          <div class="ml-4">
            <button class="p-0 border-0 bg-transparent" v-on:click="changeProfissional();">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(49, 47, 79, 1);">
                <path
                  d="M4 21a1 1 0 0 0 .24 0l4-1a1 1 0 0 0 .47-.26L21 7.41a2 2 0 0 0 0-2.82L19.42 3a2 2 0 0 0-2.83 0L4.3 15.29a1.06 1.06 0 0 0-.27.47l-1 4A1 1 0 0 0 3.76 21 1 1 0 0 0 4 21zM18 4.41 19.59 6 18 7.59 16.42 6zM5.91 16.51 15 7.41 16.59 9l-9.1 9.1-2.11.52z">
                </path>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <h5 class="mt-5 mb-4">Selecione uma data</h5>

      <div class="card" v-if="profissional.schedules && profissional.schedules.dates && profissional.schedules.dates.length == 0">
        <div class="card-body text-center">
          No momento não há horários disponíveis para este profissional.
        </div>
      </div>
      <div v-else>
        <button class="mb-2 p-0 border-0 bg-transparent w-100 text-left" v-for="(d, index) in profissional.schedules.dates" :key="index" v-on:click="selectDate(index);">
          <div class="card mb-0">
            <div class="card-body py-2 d-flex justify-content-between align-items-center">
              <div class="flex-fill">
                <h6 class="m-0 text-dark">
                  <strong>{{ d.date }}</strong>
                  <span class="ml-2 rounded font-size-11 text-uppercase">{{ d.week }}</span>
                </h6>
              </div>
              <div class="ml-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(50, 47, 79, 1);">
                  <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path>
                </svg>
              </div>
            </div>
          </div>
        </button>
      </div>
    </template>

    <template v-else-if="step == 4">
      <div class="d-flex justify-content-between align-items-center mb-5">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(50, 47, 79, 1);">
            <path
              d="M16.97 4.757a.999.999 0 0 0-1.918-.073l-3.186 9.554-2.952-6.644a1.002 1.002 0 0 0-1.843.034L5.323 12H2v2h3.323c.823 0 1.552-.494 1.856-1.257l.869-2.172 3.037 6.835c.162.363.521.594.915.594l.048-.001a.998.998 0 0 0 .9-.683l2.914-8.742.979 3.911A1.995 1.995 0 0 0 18.781 14H22v-2h-3.22l-1.81-7.243z">
            </path>
          </svg>
        </div>
        <div class="ml-2 flex-fill">
          <h5 class="mb-0">{{ especialidade.name }}</h5>
        </div>
        <button class="btn btn-outline-default py-1 rounded-sm" v-on:click="changeEspecialidade();">Alterar</button>
      </div>

      <div class="card card-icon mb-2">
        <div class="card-body d-flex align-items-center">
          <div v-if="profissional.image">
            <img class="rounded-circle header-profile-user" :src="profissional.image" alt="" />
          </div>
          <div v-else class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
              <path d="M15 2.013H9V9H2v6h7v6.987h6V15h7V9h-7z"></path>
            </svg>
          </div>
          <div class="ml-3 w-75 pt-1">
            <h5 class="m-0 text-dark font-size-16"><strong>{{ profissional.name }}</strong></h5>
            <p class="m-0 text-dark text-uppercase">{{ profissional.class }} – {{ profissional.region }} {{ profissional.register }}</p>
          </div>
          <div class="ml-4">
            <button class="p-0 border-0 bg-transparent" v-on:click="changeProfissional();">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(49, 47, 79, 1);">
                <path
                  d="M4 21a1 1 0 0 0 .24 0l4-1a1 1 0 0 0 .47-.26L21 7.41a2 2 0 0 0 0-2.82L19.42 3a2 2 0 0 0-2.83 0L4.3 15.29a1.06 1.06 0 0 0-.27.47l-1 4A1 1 0 0 0 3.76 21 1 1 0 0 0 4 21zM18 4.41 19.59 6 18 7.59 16.42 6zM5.91 16.51 15 7.41 16.59 9l-9.1 9.1-2.11.52z">
                </path>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div class="card card-icon">
        <div class="card-body d-flex align-items-center">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
              <path d="M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"></path>
              <path d="m11 17.414 5.707-5.707-1.414-1.414L11 14.586l-2.293-2.293-1.414 1.414z"></path>
            </svg>
          </div>
          <div class="ml-3 w-75 pt-1">
            <h5 class="m-0 text-dark font-size-16"><strong>{{ profissional.schedules.dates[this.date].date }}</strong></h5>
            <p class="m-0 text-dark font-size-13 text-uppercase">{{ profissional.schedules.dates[this.date].week }}</p>
          </div>
          <div class="ml-4">
            <button class="p-0 border-0 bg-transparent" v-on:click="changeDate();">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(49, 47, 79, 1);">
                <path
                  d="M4 21a1 1 0 0 0 .24 0l4-1a1 1 0 0 0 .47-.26L21 7.41a2 2 0 0 0 0-2.82L19.42 3a2 2 0 0 0-2.83 0L4.3 15.29a1.06 1.06 0 0 0-.27.47l-1 4A1 1 0 0 0 3.76 21 1 1 0 0 0 4 21zM18 4.41 19.59 6 18 7.59 16.42 6zM5.91 16.51 15 7.41 16.59 9l-9.1 9.1-2.11.52z">
                </path>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <h5 class="mt-5 mb-4">Selecione um horário</h5>

      <div class="card" v-if="profissional.schedules && profissional.schedules.hours && profissional.schedules.hours.length == 0">
        <div class="card-body text-center">
          No momento não há horários disponíveis para este profissional.
        </div>
      </div>
      <div v-else>
        <button class="mb-2 p-0 border-0 bg-transparent w-100 text-left" v-for="(h, index) in profissional.schedules.hours[this.date]" :key="index" v-on:click="selectHour(index);">
          <div class="card mb-0">
            <div class="card-body py-2 d-flex justify-content-between align-items-center">
              <div class="flex-fill">
                <h6 class="m-0 text-dark">
                  <strong>{{ h.hour }}</strong>
                </h6>
              </div>
              <div class="ml-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(50, 47, 79, 1);">
                  <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path>
                </svg>
              </div>
            </div>
          </div>
        </button>
      </div>
    </template>

    <template v-else-if="step == 5">
      <div class="d-flex justify-content-between align-items-center mb-5">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(50, 47, 79, 1);">
            <path
              d="M16.97 4.757a.999.999 0 0 0-1.918-.073l-3.186 9.554-2.952-6.644a1.002 1.002 0 0 0-1.843.034L5.323 12H2v2h3.323c.823 0 1.552-.494 1.856-1.257l.869-2.172 3.037 6.835c.162.363.521.594.915.594l.048-.001a.998.998 0 0 0 .9-.683l2.914-8.742.979 3.911A1.995 1.995 0 0 0 18.781 14H22v-2h-3.22l-1.81-7.243z">
            </path>
          </svg>
        </div>
        <div class="ml-2 flex-fill">
          <h5 class="mb-0">{{ especialidade.name }}</h5>
        </div>
        <button class="btn btn-outline-default py-1 rounded-sm" v-on:click="changeEspecialidade();">Alterar</button>
      </div>

      <div class="card card-icon mb-2">
        <div class="card-body d-flex align-items-center">
          <div v-if="profissional.image">
            <img class="rounded-circle header-profile-user" :src="profissional.image" alt="" />
          </div>
          <div v-else class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
              <path d="M15 2.013H9V9H2v6h7v6.987h6V15h7V9h-7z"></path>
            </svg>
          </div>
          <div class="ml-3 w-75 pt-1">
            <h5 class="m-0 text-dark font-size-16"><strong>{{ profissional.name }}</strong></h5>
            <p class="m-0 text-dark text-uppercase">{{ profissional.class }} – {{ profissional.region }} {{ profissional.register }}</p>
          </div>
          <div class="ml-4">
            <button class="p-0 border-0 bg-transparent" v-on:click="changeProfissional();">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(49, 47, 79, 1);">
                <path
                  d="M4 21a1 1 0 0 0 .24 0l4-1a1 1 0 0 0 .47-.26L21 7.41a2 2 0 0 0 0-2.82L19.42 3a2 2 0 0 0-2.83 0L4.3 15.29a1.06 1.06 0 0 0-.27.47l-1 4A1 1 0 0 0 3.76 21 1 1 0 0 0 4 21zM18 4.41 19.59 6 18 7.59 16.42 6zM5.91 16.51 15 7.41 16.59 9l-9.1 9.1-2.11.52z">
                </path>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div class="card card-icon mb-2">
        <div class="card-body d-flex align-items-center">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
              <path d="M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"></path>
              <path d="m11 17.414 5.707-5.707-1.414-1.414L11 14.586l-2.293-2.293-1.414 1.414z"></path>
            </svg>
          </div>
          <div class="ml-3 w-75 pt-1">
            <h5 class="m-0 text-dark font-size-16"><strong>{{ profissional.schedules.dates[this.date].date }}</strong></h5>
            <p class="m-0 text-dark font-size-13 text-uppercase">{{ profissional.schedules.dates[this.date].week }}</p>
          </div>
          <div class="ml-4">
            <button class="p-0 border-0 bg-transparent" v-on:click="changeDate();">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(49, 47, 79, 1);">
                <path
                  d="M4 21a1 1 0 0 0 .24 0l4-1a1 1 0 0 0 .47-.26L21 7.41a2 2 0 0 0 0-2.82L19.42 3a2 2 0 0 0-2.83 0L4.3 15.29a1.06 1.06 0 0 0-.27.47l-1 4A1 1 0 0 0 3.76 21 1 1 0 0 0 4 21zM18 4.41 19.59 6 18 7.59 16.42 6zM5.91 16.51 15 7.41 16.59 9l-9.1 9.1-2.11.52z">
                </path>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div class="card card-icon">
        <div class="card-body d-flex align-items-center">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
              <path
                d="m20.145 8.27 1.563-1.563-1.414-1.414L18.586 7c-1.05-.63-2.274-1-3.586-1-3.859 0-7 3.14-7 7s3.141 7 7 7 7-3.14 7-7a6.966 6.966 0 0 0-1.855-4.73zM15 18c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z">
              </path>
              <path d="M14 10h2v4h-2zm-1-7h4v2h-4zM3 8h4v2H3zm0 8h4v2H3zm-1-4h3.99v2H2z"></path>
            </svg>
          </div>
          <div class="ml-3 w-75 pt-1">
            <h5 class="m-0 text-dark font-size-16"><strong>{{ profissional.schedules.hours[this.date][this.hour].hour }}</strong></h5>
          </div>
          <div class="ml-4">
            <button class="p-0 border-0 bg-transparent" v-on:click="changeHour();">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(49, 47, 79, 1);">
                <path
                  d="M4 21a1 1 0 0 0 .24 0l4-1a1 1 0 0 0 .47-.26L21 7.41a2 2 0 0 0 0-2.82L19.42 3a2 2 0 0 0-2.83 0L4.3 15.29a1.06 1.06 0 0 0-.27.47l-1 4A1 1 0 0 0 3.76 21 1 1 0 0 0 4 21zM18 4.41 19.59 6 18 7.59 16.42 6zM5.91 16.51 15 7.41 16.59 9l-9.1 9.1-2.11.52z">
                </path>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <button class="mt-4 btn btn-default btn-lg btn-block" v-on:click="showConfirmar();">
        Confirmar agendamento
      </button>
    </template>

    <b-modal v-model="confirm.modal" modal-class="modal-bottom" hide-header hide-footer>
      <h4 class="mb-4">Confirmar agendamento?</h4>
      <p class="mb-2">Quem irá consultar</p>
      <div class="card">
        <div class="card-body py-2 d-flex align-items-center">
          <div>
            <img v-if="account.user.avatar" class="rounded-circle header-profile-user" :src="account.user.avatar" alt="" />
            <img v-else class="rounded-circle header-profile-user" :src="'https://ui-avatars.com/api/?background=37228C&color=fff&name=' + account.user.name" alt="" />
          </div>
          <div class="ml-3">{{ account.user.name }}</div>
        </div>
      </div>
      <p class="mb-2">Motivo da consulta</p>
      <div class="card border-top-0 border-left-0 border-right-0 border-bottom">
        <div class="card-body p-0 rounded">
          <textarea v-model="motive" class="form-control" rows="5" maxrows="5"></textarea>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center">
        <button class="btn btn-default btn-lg mr-3" v-on:click="sendAgendamento();" :disabled="this.confirm.loading">
          Confirmar
          <b-spinner v-if="confirm.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
        </button>
        <a class="btn btn-outline-link" v-on:click="confirm.modal = false">Fechar</a>
      </div>
    </b-modal>
  </Layout>
</template>

<style>
.p-component,
.p-inputtext {
  font-family: Poppins !important;
  font-size: 14px;
}

.p-dropdown {
  width: 100%;
}

.p-hidden-accessible {
  display: none;
}

.p-dropdown-panel {
  width: 100%;
  left: 0;
}

.p-dropdown-items {
  padding: 0 !important;
}

.p-dropdown-trigger {
  border-bottom: solid 1px #DEDEDE !important;
}

.p-dropdown-label,
.p-dropdown-item {
  display: flex;
  align-items: center;
  white-space: normal;
  border-bottom: solid 1px #DEDEDE !important;
  padding: 0.5rem 1.2rem !important;
  height: 50px;
}

.p-placeholder {
  line-height: 50px;
}

.p-dropdown-row {
  margin-left: 10px;
  word-wrap: break-word;
  font-size: 14px;
  color: #000;
  line-height: 20px;
}

.p-dropdown-title {
  margin-left: 10px;
  word-wrap: break-word;
  font-size: 15px;
  font-weight: 500;
  color: #000;
  line-height: 20px;
}

.p-highlight {
  background: #dedede !important;
}
</style>